import {
    FirstAccessRequest,
    ForgotPasswordRequest,
    ImportDetails,
    ImportHistory,
    ImportHistoryRequest,
    Person,
    PersonPostPutRequest,
    PersonRequest,
    UserActiveRequest,
} from '@/models/Person';
import { AxiosError } from 'axios';
import { action } from 'typesafe-actions';
import { People, PeopleTypes, PersonResponse, PersonState } from './types';

export const getPeopleRequest = (data: PersonRequest) => action(PeopleTypes.GET_PEOPLE_REQUEST, data);
export const getPeopleSuccess = (data: People) => action(PeopleTypes.GET_PEOPLE_SUCCESS, data);
export const getPeopleFailure = (error: AxiosError) => action(PeopleTypes.GET_PEOPLE_FAILURE, error);
export const getPeopleClear = () => action(PeopleTypes.GET_PEOPLE_CLEAR);

export const activeUserRequest = (data: UserActiveRequest) => action(PeopleTypes.ACTIVE_REQUEST, data);
export const activeUserSuccess = (data: UserActiveRequest) => action(PeopleTypes.ACTIVE_SUCCESS, data);
export const activeUserFailure = (error: AxiosError) => action(PeopleTypes.ACTIVE_FAILURE, error);

export const firstAccessRequest = (data: FirstAccessRequest) => action(PeopleTypes.FIRST_ACCESS_REQUEST, data);
export const firstAccessSuccess = () => action(PeopleTypes.FIRST_ACCESS_SUCCESS);
export const firstAccessFailure = (error: AxiosError) => action(PeopleTypes.FIRST_ACCESS_FAILURE, error);

export const forgotPasswordRequest = (data: ForgotPasswordRequest) => action(PeopleTypes.FORGOT_PASSWORD_REQUEST, data);
export const forgotPasswordSuccess = () => action(PeopleTypes.FORGOT_PASSWORD_SUCCESS);
export const forgotPasswordFailure = (error: AxiosError) => action(PeopleTypes.FORGOT_PASSWORD_FAILURE, error);

export const postPersonRequest = (data: PersonPostPutRequest) => action(PeopleTypes.POST_PERSON_REQUEST, data);
export const postPersonSuccess = (data: PersonResponse) => action(PeopleTypes.POST_PERSON_SUCCESS, data);
export const putPersonRequest = (data: PersonPostPutRequest) => action(PeopleTypes.PUT_PERSON_REQUEST, data);
export const putPersonSuccess = () => action(PeopleTypes.PUT_PERSON_SUCCESS);
export const handlePersonFailure = (error: AxiosError) => action(PeopleTypes.HANDLE_PERSON_FAILURE, error);
export const handlePersonClear = () => action(PeopleTypes.HANDLE_PERSON_CLEAR);

export const getPersonRequest = (personId: number, personOnly: boolean = false) => action(PeopleTypes.GET_PERSON_REQUEST, { personId, personOnly });
export const getPersonSuccess = (data: PersonState) => action(PeopleTypes.GET_PERSON_SUCCESS, data);
export const getPersonFailure = (error: AxiosError) => action(PeopleTypes.GET_PERSON_FAILURE, error);
export const getPersonClear = () => action(PeopleTypes.GET_PERSON_CLEAR);

export const getImportHistoryRequest = (data: ImportHistoryRequest) => action(PeopleTypes.GET_IMPORT_HISTORY_REQUEST, data);
export const getImportHistorySuccess = (data: ImportHistory[]) => action(PeopleTypes.GET_IMPORT_HISTORY_SUCCESS, data);
export const getImportHistoryFailure = (error: AxiosError) => action(PeopleTypes.GET_IMPORT_HISTORY_FAILURE, error);
export const getImportHistoryClear = () => action(PeopleTypes.GET_IMPORT_HISTORY_CLEAR);

export const getImportDetailRequest = (data: { id: number; limit?: number; offset?: number; error?: boolean; success?: boolean; search?: string }) =>
    action(PeopleTypes.GET_IMPORT_DETAIL_REQUEST, data);
export const getImportDetailSuccess = (response: { data: ImportDetails[]; total: number }) => action(PeopleTypes.GET_IMPORT_DETAIL_SUCCESS, response);
export const getImportDetailFailure = (error: AxiosError) => action(PeopleTypes.GET_IMPORT_DETAIL_FAILURE, error);
export const getImportDetailClear = () => action(PeopleTypes.GET_IMPORT_DETAIL_CLEAR);

export const getTotalPeopleRequest = (data: PersonRequest) => action(PeopleTypes.GET_TOTAL_ACTIVE_PEOPLE_REQUEST, data);
export const getTotalActivePeopleSuccess = (data: number) => action(PeopleTypes.GET_TOTAL_ACTIVE_PEOPLE_SUCCESS, data);
export const getTotalRegisteredPeopleSuccess = (data: number) => action(PeopleTypes.GET_TOTAL_REGISTERED_PEOPLE_SUCCESS, data);
export const getTotalActivePeopleFailure = (error: AxiosError) => action(PeopleTypes.GET_TOTAL_ACTIVE_PEOPLE_FAILURE, error);

export const updateMyPersonRequest = () => action(PeopleTypes.REFRESH_MY_PERSON_REQUEST);
export const updateMyPersonSuccess = (data: Person) => action(PeopleTypes.REFRESH_MY_PERSON_SUCCESS, data);
export const updateMyPersonFailure = (error: AxiosError) => action(PeopleTypes.REFRESH_MY_PERSON_FAILURE, error);

export const getPublicPersonRequest = (personId: number) => action(PeopleTypes.GET_PUBLIC_PERSON_REQUEST, personId);
export const getPublicPersonSuccess = (data: Person) => action(PeopleTypes.GET_PUBLIC_PERSON_SUCCESS, data);
export const getPublicPersonFailure = (error: AxiosError) => action(PeopleTypes.GET_PUBLIC_PERSON_FAILURE, error);
export const getPublicPersonClear = () => action(PeopleTypes.GET_PUBLIC_PERSON_CLEAR);
